module.exports = __webpack_public_path__ + "public/img/icons/nft_sparkle.gif";